import {
  Button,
  MConfirmation,
  Textarea,
  YearDropdown,
  GeneralDropdown,
  Input,
  MCardSavedOffer,
} from './../../../../components';
import {
  userMail,
  LetterIcon,
  SuccessAddOffer,
} from '../../../../assets/icons';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../languages/i18n';
import Counter from './../../../../components/inputs/Counter';
import {
  useForm,
  Controller,
  useFieldArray,
} from 'react-hook-form';
import {
  getAllCarBrands,
  getColors,
  getCities,
  getModelsOfBrand,
  getOffer,
  updateOffer,
  getAllSavedOffersForMediator,
} from './../../../../services/apis/offer';
import { useNavigate, useParams } from 'react-router-dom';
import {
  FaTimesCircle,
  FaUpload,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { toastConfig, userRole } from './../../../../helpers/helper';
import { uploadFiles } from './../../../../services/apis/general';
import { getUserInfo } from '../../../../services/apis/user';
import { useFormOfferContext } from './../../../../context/FormOfferContext';
import ListImages from './ListImages';
import ListFiles from './ListFiles';

const EditOffer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const isArabic = i18n.language === 'ar';
  const [openModal, setOpenModal] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [cities, setCities] = useState([]);
  const [colors, setColors] = useState([]);
  const [formCount, setFormCount] = useState(1);
  const [openSavedOffers, setOpenSavedOffers] = useState(false);
  const [savedOffers, setSavedOffers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [offer, setOffer] = useState({});
  const [userType, setUserType] = useState('true');
  const [userInfo, setUserInfo] = useState('');
  const [priceType, setPriceType] = useState('CASH');

  const handleChangeUserType = (e) => {

    setUserType(e.target.value);
  };
  const handleChangePriceType = (index, e) => {
    setPriceType(e.target.value);
  };
  const yearOptions = Array.from({ length: 25 }, (_, index) => 2000 + index);

  const closeModal = () => {
    setOpenModal(false);
  };

  const { control, handleSubmit, watch, reset, register, setValue, getValues } =
    useForm({
      defaultValues: {
        cars:[],
      },
    });


  const { fields, append, remove } = useFieldArray({
    control,
    name: 'cars', // This will store the cars' data in an array,
  });

  const description = watch('description', '');


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getOffer('', id);
        const offerData = response;

        setOffer(offerData);
   
        
        setPriceType(
          /%/.test(offerData.cars?.[0]?.commission) ? 'PERCENTAGE' : 'CASH'
        );
        setUserType(offerData.isCarsOwner.toString());
        offerData?.cars.forEach((car, index) => {
          append({
            userType: car.userType || '',
            description: car?.description || '',
            brandId: car?.brand?.id || 0,
            modelId: car?.model?.id || 0,
            price: car?.price || 0,
            modelYear: car?.modelYear || 0,
            cityId: car?.city?.id || null,
            commission: /%/.test(car?.commission)
              ? car?.commission.replace('%', '')
              : car?.commission || 0,
            commissionType: /%/.test(car?.commission) ? 'PERCENTAGE' : 'CASH',
            colorId: car?.color?.id || null,
            odo: car?.odo || 0,
            filesUrl: car?.filesUrl || [],
          });
        });
        offerData?.cars.forEach((car, index) => {
          otherAction(car?.brand?.id);

        });
      } catch (error) {
        console.error('Error fetching car data:', error);
      }
    };

    fetchData(); // Call the fetch function
  }, [append]);



  const handleEditOfferSubmit = async (data) => {
    setLoading(true);
    try {
      

      if(data.cars.length == 0){
        toast.error(
          t('offerCycle.atListOneOffer'),
          toastConfig,
          setLoading(false)
        );
        return true
      }


     
      data.cars.forEach((item, index) => {
        item.commission =
          item.commissionType == 'PERCENTAGE'
            ? item.commission + '%'
            : item.commission;
      });

      const payload = {
        requestId: offer.requestId,
        cars: data.cars,
        buyerId: offer?.buyerRequest?.buyerInfo?.id,
        isCarOwner: userType,
      };

      const response = await updateOffer(payload, id);

      // Check the response structure and status
      setOpenModal(true);
      toast.success(
        t('offerCycle.editOfferSuccess'),
        toastConfig,
        setLoading(false)
      );

      setTimeout(() => {
        navigate('/offers');
      }, 1500);
      
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          
          if (
            error.response.data.message ==
            `Model with ID: 0 is not associated with Brand ID: ${data.brandId}.`
          ) {
            toast.error(
              t(`myOrders.validationModel`),
              toastConfig,
              setLoading(false)
            );
          } else if (
            error.response.data.message == 'Invalid model year value.'
          ) {
            toast.error(
              t(`myOrders.validationModelYear`),
              toastConfig,
              setLoading(false)
            );
          } else if (error.response.data.message == 'Invalid price value.') {
            toast.error(
              t(`myOrders.validationPrice`),
              toastConfig,
              setLoading(false)
            );
          } else if (error.response.data.message == 'Commission is required.') {
            toast.error(
              t(`myOrders.commissionRequired`),
              toastConfig,
              setLoading(false)
            );
          } else if (
            error.response.data.message ==
            'There is pending offer, only one offer can mediator add to request'
          ) {
            toast.error(
              t(`myOrders.pendingOffer`),
              toastConfig,
              setLoading(false)
            );
          } else if (
            error.response.data.message ==
            "{cars[0].description=يجب أن يكون الحجم بين 0 و2000}"
          ) {
            toast.error(
              t(`myOrders.lengthDescription`),
              toastConfig,
              setLoading(false)
            );
          }
        } else if (error.response.status == 500) {
          toast.error(
            error.response.data.message,
            toastConfig,
            setLoading(false)
          );
        }
      }
      console.error('Error submitting offer:', error);
    }
  };


  const getAllSavedOffers = async (text) => {
    let data = {
      params: {
        searchText: text,
      },
    };
    const response = await getAllSavedOffersForMediator(data);
    setSavedOffers(response.data.items);
  };


  const handleSearch = (e) => {
    setSearchText(e.target.value,getAllSavedOffers(e.target.value));
  };

  useEffect(() => {
    // Fetch all brands, colors, and cities on component load
    const fetchInitialData = async () => {
      const brandData = await getAllCarBrands();
      const colorData = await getColors();
      const cityData = await getCities();
      const userDate = await getUserInfo();
      setUserInfo(userDate);

      if (brandData) {
        const formattedBrands = brandData.map((brand) => ({
          value: brand.id,
          label: isArabic ? brand.nameAr : brand.nameEn,
          icon: brand.image,
        }));
        setBrands(formattedBrands);
      }

      if (colorData) {
        const formattedColors = colorData?.data?.items?.map((color) => ({
          value: color.id,
          label: isArabic ? color.nameAr : color.nameEn,
        })).slice(0, -1);
        setColors(formattedColors);
      }

      if (cityData) {
        const formattedCities = cityData.map((city) => ({
          value: city.id,
          label: isArabic ? city.nameAr : city.nameEn,
        }));
        setCities(formattedCities);
      }
    };

    fetchInitialData();
  }, []);

  const otherAction = async (brandId) => {
    const response = await getModelsOfBrand(brandId);
    const allModels = response.flat().map((model) => ({
      value: model.id,
      label: isArabic ? model.nameAr : model.nameEn,
    }));
    setModels(allModels);
  };

  

  const uploadFile = async (data, index, type) => {
    setLoadingFiles(true);

    const formData = new FormData();

    data.forEach((file) => {
      formData.append('files', file);
    });

    try {
      const response = await uploadFiles(formData);

      const uploadedFileUrls = response.map((file) => file);

      const currentFiles = getValues(`cars.${index}.filesUrl`) || [];

      setValue(`cars.${index}.filesUrl`, [
        ...uploadedFileUrls,
        ...currentFiles,
      ]);
      allFiles(index);
    

      toast.success(t('myOrders.fileUploaded'), toastConfig);
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.message || 'An error occurred';
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error(errorMessage, toastConfig);
        }
      }
    } finally {
      setLoadingFiles(false);
    }
  };

  const handleAddForm = (offer) => {
    setFormCount((prev) => prev + 1);
    if(!offer){
      append({
        description: '',
        brandId: 0,
        modelId: 0,
        price: 0,
        modelYear: 0,
        cityId: null,
        commission: 0,
        commissionType: 0,
        colorId: null,
        odo: 0,
        filesUrl: [],
      });
    }else{
      append({
        description: offer?.description || '',
        brandId: offer?.car?.id || 0,
        modelId: offer?.car?.model?.id || 0,
        price: offer?.price ?? 0,
        modelYear: offer?.modelYear ?? 0,
        cityId: offer?.city?.id ?? null,
        commission: offer?.commission ?? 0,
        commissionType: offer?.commissionType ?? 0,
        colorId: offer?.color?.id ?? null,
        odo: offer?.odo ?? 0,
        filesUrl: offer?.carFiles || [],
    });
    otherAction(offer?.car?.id);
    setOpenSavedOffers(false)
  }
  


  
  };

  const handleSaveForm = (data) => {
    handleEditOfferSubmit(data);
  };

  const handleChangeFiles = (e, index, type) => {
    const files = e.target.files;
    const filesArray = Array.from(files);

    uploadFile(filesArray, index, type);
  };

  const allFiles = (index) => {
    let newFiles = [];
    let newImages = [];

    const files = getValues(`cars.${index}.filesUrl`);

    if (Array.isArray(files)) {
      files.forEach((file) => {
        if (typeof file === 'string') {
          const fileExtension = file.split('.').pop().toLowerCase();
          if (['pdf', 'docx', 'doc','xlsx', 'xls'].includes(fileExtension)) {
            newFiles.push(file);
          } else {
            newImages.push(file);
          }
        } else if (file instanceof File) {
          const fileExtension = file.name.split('.').pop().toLowerCase();
          if (['pdf', 'docx', 'doc','xlsx', 'xls'].includes(fileExtension)) {
            newFiles.push(file);
          } else {
            newImages.push(file);
          }
        } else {
          console.warn('Unknown file type:', file);
        }
      });
    }


    return { newFiles, newImages };
  };

  return (
    <div className="bg-gradient-to-b from-[#FFFFFF] to-[#D7E2FF] p-10">
      <div className="w-[90%] mr-auto ml-auto">
        <div className="text-[17px] text-[#000000] font-500 text-center mb-10">
          {t('offerCycle.titleEditOffer')}
        </div>
        <form onSubmit={handleSubmit(handleSaveForm)}>
          {fields?.map((car, index) => (
            <div
              key={car.id}
              className="border border-[#3E0292] rounded-[12px] my-5 p-4 relative"
            >
              <FaTimesCircle
                onClick={() => remove(index)}
                className="text-[30px] text-[#ff0000] absolute left-[-20px] top-[-20px] cursor-pointer"
              />
              <div className="grid md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 gap-x-4 mb-4 gap-4">
                <GeneralDropdown
                  otherAction={otherAction}
                  useAction={true}
                  maxWidth={false}
                  control={control}
                  name={`cars[${index}].brandId`}
                  icon={userMail}
                  label={t('myOrders.brandCar')}
                  placeholder={t('myOrders.selectBrandCar')}
                  options={brands}
                />
                <GeneralDropdown
                  maxWidth={false}
                  control={control}
                  name={`cars[${index}].modelId`}
                  icon={LetterIcon}
                  label={t('myOrders.carType')}
                  placeholder={t('myOrders.selectCarType')}
                  options={models}
                />
                <GeneralDropdown
                  maxWidth={false}
                  control={control}
                  name={`cars[${index}].cityId`}
                  icon={userMail}
                  label={t('myOrders.city')}
                  placeholder={t('myOrders.selectCity')}
                  options={cities}
                />
                <GeneralDropdown
                  maxWidth={false}
                  control={control}
                  name={`cars[${index}].colorId`}
                  icon={LetterIcon}
                  label={t('myOrders.color')}
                  placeholder={t('myOrders.selectColor')}
                  options={colors}
                />
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 gap-x-4 mt-4">
                <div className="grid md:grid-cols-1 lg:grid-cols-1 2xl:grid-cols-1 xl:grid-cols-1 sm:grid-cols-1 w-[100%]">
                  <YearDropdown
                    maxWidth={false}
                    control={control}
                    name={`cars[${index}].modelYear`}
                    icon={userMail}
                    label={t('listOrdersCarOwner.year')}
                    placeholder={t('myOrders.from')}
                    options={yearOptions.map((year) => ({
                      value: year,
                      label: year,
                    }))}
                  />
                </div>
                <div className="grid md:grid-cols-1 lg:grid-cols-1 2xl:grid-cols-1 xl:grid-cols-1 sm:grid-cols-1 gap-x-4">
                  <Controller
                    name={`cars[${index}].odo`}
                    defaultValue={car?.odo || 0}
                    control={control}
                    render={({ field }) => (
                      <Counter
                        {...field}
                        initialValue={car?.odo || 0}
                        icon={LetterIcon}
                        label={t('myOrders.kilometers')}
                        placeholder={t('myOrders.from')}
                        step={10000}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 gap-x-4 mt-5">
                <div className="flex flex-col">
              <div className="grid md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 sm:grid-cols-2 gap-x-4">
                <Controller
                  name={`cars[${index}].price`}
                  control={control}
                  defaultValue={car?.price || 0 }
                  render={({ field }) => (
                    <Counter
                      {...field}
                      icon={userMail}
                      initialValue={car?.price || 0}
                      label={t('myOrders.price')}
                      placeholder={t('myOrders.from')}
                      className="mt-2 w-[100%]"
                      step={10000}
                    />
                  )}
                />
                {userType == 'false' && (
                  <Controller
                    name={`cars[${index}].commission`}
                    control={control}
                    render={({ field }) => (
                      <Input
                        {...field}
                        icon={userMail}
                        label={t('offerCycle.commission')}
                        placeholder={
                            t('offerCycle.commissionRial')
                        }
                        type={'number'}
                        min={'0'}
                        useClassName={true}
                        className="rounded-lg border-[#D9D9D9] text-[#9E9E9E] text-[13px] w-[100%] mt-3 p-1 font-400"
                      />
                    )}
                    />
                )}
                  </div>

                  <div class="w-full mx-auto mt-5">
                    <label class="block border bg-[#ffffff] border-gray-300 rounded-lg p-2 flex items-center cursor-pointer w-[100%] p-3">
                      <FaUpload className="text-[#3E0292]" />
                      <div className="text-[#3E0292] font-400 mx-3">
                        {t('myOrders.addImages')}
                      </div>
                      <input
                        type="file"
                        className="hidden"
                        multiple={true}
                        label={t('myOrders.addImages')}
                        placeholder={t('myOrders.selectImages')}
                        onChange={(e) => handleChangeFiles(e, index, 'images')}
                        accept=".jpeg,.jpg,.png"
                      />
                    </label>
                  </div>
                  <ListImages
                    index={index}
                    allFiles={allFiles}
                    setValue={setValue}
                    getValues={getValues}
                  />

                  <div class="w-full mx-auto mt-5">
                    <label class="block border bg-[#ffffff] border-gray-300 rounded-lg p-2 flex items-center cursor-pointer w-[100%] p-3">
                      <FaUpload className="text-[#3E0292]" />
                      <div className="text-[#3E0292] font-400 mx-3">
                        {t('myOrders.uploadFiles')}
                      </div>
                      <input
                        type="file"
                        className="hidden"
                        multiple={true}
                        label={t('myOrders.uploadFiles')}
                        placeholder={t('myOrders.selectFiles')}
                        onChange={(e) => handleChangeFiles(e, index, 'files')}
                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                      />
                    </label>
                  </div>
                  <ListFiles
                    index={index}
                    allFiles={allFiles}
                    setValue={setValue}
                    getValues={getValues}
                  />
                </div>
                <div className="flex flex-col max600:mt-5 sm:mt-5">
                  <Controller
                    name={`cars[${index}].description`}
                    control={control}
                    render={({ field }) => (
                      <Textarea
                        rows={5}
                        label={t('myOrders.descriptionCar')+ "  " +"("+description.length+"/"+2000+")"}
                        placeholder={t('myOrders.descriptionCar')}
                        {...field}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          ))}

          <div className="grid max600:mt-1 max800:mt-1 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-3 xl:grid-cols-3 sm:grid-cols-2 w-[50%] mr-auto ml-auto gap-x-2 mt-5">
            <Button
              type="submit"
              loading={loading}
              title={t('offerCycle.save')}
              dark={false}
              className="bg-[#00CEBC] border border-[#00CEBC]"
            />
            <Button
              onClick={()=>handleAddForm("")}
              type="button"
              title={t('offerCycle.addNewCar')}
              dark={true}
              className="bg-[#3E0292] border border-[#3E0292] max600:mt-3 sm:mt-3 xl:mt-0 lg:mt-0 2xl:mt-0 md:mt-0"
            />

           <Button
              onClick={()=>setOpenSavedOffers(true,getAllSavedOffers(""))}
              title={t("offerCycle.chooseFromSavedOffers")}
              dark={true}
              className="bg-[#3E0292] border border-[#3E0292] max600:mt-3 sm:mt-3 xl:mt-0 lg:mt-0 2xl:mt-0 md:mt-0"
            />
          </div>
        </form>
        <MConfirmation
          openModal={openModal}
          title={t('offerCycle.editOfferSuccess')}
          showFooter={false}
          content={
            <div className="flex items-center justify-center">
              <img
                src={SuccessAddOffer}
                className="w-54 h-54 mb-2"
                alt="Registration Success"
              />
            </div>
          }
        />

         <MConfirmation
          openModal={openSavedOffers}
          title={t("offerCycle.savedOffers")}
          showFooter={false}
          content={
            <div>
              <Input onChange={handleSearch} value={searchText} placeholder={t("offerCycle.search")} />
            <div
            className={`grid md:grid-cols-2 2xl:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-4 ${userRole == 3 ? 'gap-y-4' : 'gap-y-16'}  my-5`}
          >
            {savedOffers.map((offer, index) => (
              <div key={index}>
                <MCardSavedOffer
                  key={offer.id}
                  offer={offer}
                  onClick={() =>
                    handleAddForm(offer)
                  }
                />
              </div>
            ))}
          </div>
          </div>
          }
        />
      </div>
    </div>
  );
};

export default EditOffer;
